import {z} from 'zod';

export const ProgressReportWarningObjectSchema = z.object({});

export const ProgressReportSchema = z.object({
	percentComplete: z.number().int().positive(),
	percentLastLogged: z.number().int().positive(),
	jobTitle: z.string(),
	secondsToReload: z.number().int().positive(),
	completeUrl: z.string().nullable(),
	details: z.string(),
	increment: z.number().int().positive(),
	startTime: z.number().int().positive(),
	runningTime: z.number().int().positive(),
	runningTimeLabel: z.string().nullable(),
	estimatedTime: z.number().int().positive().nullable(),
	userId: z.number().int().positive(),
	notifyOnComplete: z.boolean(),
	size: z.number().int().positive(),
	progressMessages: z.string().nullable(),
	progressMessageCount: z.number().int().positive(),
	warningObject: ProgressReportWarningObjectSchema.nullable(),
});

export type IProgressReport = z.infer<typeof ProgressReportSchema>;

export type IProgressReportWarningObject = z.infer<
	typeof ProgressReportWarningObjectSchema
>;
